import React, { ReactElement } from 'react';

import { TIconProps } from './Icons.types';

function ArrowLeftIcon({
  height = 20,
  width = 11,
  iconColor = '#333',
  ...restProps
}: TIconProps): ReactElement {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 20"
      data-testid="ArrowLeftIcon"
      {...restProps}>
      <path
        d="M10.258.962a1.22 1.22 0 01-.088 1.564L3.082 10l7.088 7.474c.44.464.44 1.204 0 1.667-.22.232-.517.359-.827.359-.31 0-.608-.127-.827-.359l-7.55-7.96a1.73 1.73 0 010-2.362l7.55-7.96a1.132 1.132 0 011.654 0l.088.103z"
        fill={iconColor}
        fillRule="nonzero"
      />
    </svg>
  );
}

export default ArrowLeftIcon;
